import { c as _c } from "react/compiler-runtime";
import { userCardTooltipSx } from "@components/user-more-info-menu/user-avatar-with-menu";
import { UserMoreInfoMenu } from "@components/user-more-info-menu/user-more-info-menu";
import { Avatar, Tooltip } from "@flat-ui";
import { getUserInitials } from "@utils/user-utils";

/** React component for the avatar of a team member, with the member's card as its tooltip */
export function TeamMemberAvatar(t0) {
  const $ = _c(10);
  const {
    member
  } = t0;
  let t1;
  if ($[0] !== member) {
    t1 = getUserInitials(member);
    $[0] = member;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const initials = t1;
  let t2;
  if ($[2] !== member) {
    t2 = <UserMoreInfoMenu member={member} />;
    $[2] = member;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== initials || $[5] !== member.thumbnailUrl) {
    t3 = <Avatar alt={initials} src={member.thumbnailUrl}>{initials}</Avatar>;
    $[4] = initials;
    $[5] = member.thumbnailUrl;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <Tooltip component="div" title={t2} tooltipSx={userCardTooltipSx} disableInteractive={false}>{t3}</Tooltip>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}